export const RM_TICKET = "RM_TICKET";
export const RM_TICKET_REPORT = "RM_TICKET_REPORT";
export const RM_TICKET_DETAILS = "RM_TICKET_DETAILS";
export const RM_STATUS = "RM_STATUS";
export const GET_MATERIAL = "GET_MATERIAL";
export const RM_TICKET_FILTER = "RM_TICKET_FILTER";
export const GET_EQUIPMENT = "GET_EQUIPMENT";
export const RM_TICKET_DETAILS_FOR_UPDATION = "RM_TICKET_DETAILS_FOR_UPDATION";
export const RM_TICKET_DETAILS_SLOT = "RM_TICKET_DETAILS_SLOT";

